// src/foundation/color/additional.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
var additional = (_obj = {}, _define_property(_obj, "red100" /* Red100 */ , "#FF3E3E"), _define_property(_obj, "red80" /* Red80 */ , "#FF6666"), _define_property(_obj, "red10" /* Red10 */ , "#FFEBEB"), _define_property(_obj, "green100" /* Green100 */ , "#31B32E"), _define_property(_obj, "green80" /* Green80 */ , "#66E063"), _define_property(_obj, "green10" /* Green10 */ , "#E7F9E7"), _define_property(_obj, "yellow100" /* Yellow100 */ , "#F5B200"), _define_property(_obj, "yellow80" /* Yellow80 */ , "#FFCB40"), _define_property(_obj, "yellow10" /* Yellow10 */ , "#FFF7E0"), _define_property(_obj, "blue100" /* Blue100 */ , "#0085FF"), _define_property(_obj, "blue50" /* Blue50 */ , "#80C2FF"), _define_property(_obj, "blue10" /* Blue10 */ , "#EDF3FF"), _define_property(_obj, "orange100" /* Orange100 */ , "#FF7005"), _define_property(_obj, "orange80" /* Orange80 */ , "#FF8B34"), _define_property(_obj, "orange10" /* Orange10 */ , "#FFF0E5"), _define_property(_obj, "mint100" /* Mint100 */ , "#2EC4B6"), _define_property(_obj, "navy100" /* Navy100 */ , "#031D44"), _obj);
export { additional };
